export const LEVELS = [
  { name: "مستكشف", min: 0, icon: "Compass" },
  { name: "متعلم", min: 100, icon: "BookOpen" },
  { name: "محترف", min: 250, icon: "Medal" },
  { name: "خبير", min: 500, icon: "Gem" },
  { name: "قائد التحدي", min: 900, icon: "Crown" },
];

export function levelInfo(points = 0) {
  let idx = 0;
  for (let i = 0; i < LEVELS.length; i++) if (points >= LEVELS[i].min) idx = i;
  const current = LEVELS[idx];
  const next = LEVELS[idx + 1] || null;
  const floor = current.min;
  const ceil = next ? next.min : current.min + 400;
  const progress = Math.min(100, Math.round(((points - floor) / (ceil - floor)) * 100));
  const toNext = next ? Math.max(0, next.min - points) : 0;
  return { index: idx, current, next, progress, toNext, xp: points };
}

function hash(str) {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) & 0xffff;
  return h;
}

export const SKILL_NAMES = ["التواصل", "خدمة الزوار", "العمل الجماعي", "حل المشكلات", "الاستجابة للطوارئ", "الالتزام"];

export function skillRadar(user) {
  const completed = user?.completed_challenge_ids?.length || 0;
  const streak = user?.streak || 0;
  return SKILL_NAMES.map((name) => {
    const seed = hash((user?.name || "") + name) % 20;
    const val = Math.max(38, Math.min(98, 46 + completed * 4 + Math.floor(streak / 2) + seed));
    return { skill: name, value: val };
  });
}
